import React from 'react';
import Paper from 'material-ui/Paper';
import style from './FormContainer.scss';
import { ThemeProps } from '../../../themes/theme';

class FormContainer extends React.Component {
  static propTypes = {};
  static contextTypes = {
    muiTheme: ThemeProps
  };

  componentWillMount() {
    const { logo } = this.context.muiTheme;
    this.logo = React.createElement(logo.component || 'div', {
      className: style.logo,
      style: logo.style
    });
  }

  render() {
    return (
      <div className={style.root}>
        {this.logo}
        <div className={style.container}>
          <Paper zDepth={1} className={style.formCard}>
            {this.props.children}
          </Paper>
        </div>
        <div className={style.fakeItem}></div>
      </div>
    );
  }
}

export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/NonLoggedLayout/FormContainer/FormContainer.js